import { getData } from "../data/data";

function addNewApp(state, appId) {
  return {
    ...state,
    [appId]: {
      data: getData(appId),
      currentQuestion: 0,
      currentValues: {},
      score: 0,
    },
  };
}

function resetAppState(state, appId) {
  return {
    ...state,
    [appId]: {
      data: getData(appId),  // Re-fetch initial data if necessary
      currentQuestion: 0,
      currentValues: {},
      score: 0,
    },
  };
}

function updateQuestion(state, i, appId) {
  return {
    ...state,
    [appId]: {
      ...state[appId],
      currentQuestion: state[appId].currentQuestion + i,
    },
  };
}

const nextQuestion = (state, appId) => {
  return updateQuestion(state, +1, appId);
};

const previousQuestion = (state, appId) => {
  return updateQuestion(state, -1, appId);
};

function setScore(state, props) {
  return {
    ...state,
    [props.appId]: { ...state[props.appId], score: {...props.score} },
  };
}

function setCurrentValues(state, props) {
  return {
    ...state,
    [props.appId]: {
      ...state[props.appId],
      currentValues: {
        ...state[props.appId].currentValues,
        ...props.value,
      },
    },
  };
}

export {
  addNewApp,
  resetAppState,
  updateQuestion,
  nextQuestion,
  previousQuestion,
  setScore,
  setCurrentValues,
};
